import { Section } from '../styles'
import { numberToDollars } from '../../../utils'

const IntroHeader = ({ person, accountsBalance }) => {
  return (
    <Section.NameInvestmentWrapper>
      <Section.Name>Hi {person.displayName}!</Section.Name>
      <Section.InvestmentBalance>
        <Section.InvestmentTitle>Investment accounts balance</Section.InvestmentTitle>
        <Section.InvestmentAmount>
          ${numberToDollars(accountsBalance, true)}
        </Section.InvestmentAmount>
      </Section.InvestmentBalance>
    </Section.NameInvestmentWrapper>
  )
}
export default IntroHeader
